import { http } from '../../../lib/http'

// 定义action type
export const LOGIN = 'LOGIN'

// 指定对应api
export const api = {
  [LOGIN]: `/login/do`, // 登录
}
// 初始化store对象
const state = {
  userInfo: {},
  userTheme: 'default',
  userName: '',
}

// 异步操作放到action handler里
const actions = {
  doLogin({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const rst = await http.post(api[LOGIN], payload)
        if (rst.success) {
          const { sessionId } = rst.dataResult // eslint-disable-line
          commit('SET_USER_INFO', sessionId)
          resolve(rst)
        }
      } catch (error) {
        reject(error)
      }
    })
  },
}

// 根据commit更新store
const mutations = {
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_USER_THEME(state, theme) {
    state.userTheme = theme
  },
  SET_USER_NAME(state, username) {
    state.userName = username
  },
}

const getters = {
  userInfo(state) {
    return state.userInfo
  },
  userTheme(state) {
    return state.userTheme
  },
  userName(state) {
    return state.userName
  },
}

// 导出vuex模块
export default {
  // 模块开启命名空间
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
